import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import LoadingProgress from "../components/LoadingProgress";
import Box from "../components/Box";
import SaleList from "../components/SaleList";
import ErrorMessage from "../components/ErrorMessage";

// view specific styles
import "../styles/SalesView.css";

import SalesPlots from "../components/SalesPlots";
import SalesFilterForm from "../forms/SalesFilterForm";
import MonthYearPickerForm from "../forms/MonthYearPickerForm";
import {
  fetchSalesAnalysis,
  fetchSalesCSV,
  fetchSalesExcel,
} from "../actions/sales";
import { fetchMachines } from "../actions/machines";
import { getLockersName } from "../utils/machines";

const EXCLUDE_CUSTOMER_ID = "620d1664db950220fabc0a41"; // VACWAY TECH

class SalesView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMonthlyReport: false,
      showFilters: false,
      excludeVacway: false,
    };

    this.handleSalesCSV = this.handleSalesCSV.bind(this);
    this.handleSalesExcel = this.handleSalesExcel.bind(this);
    this.toggleMonthlyReport = this.toggleMonthlyReport.bind(this);
    this.toggleFilters = this.toggleFilters.bind(this);
    this.toggleExcludeVacway = this.toggleExcludeVacway.bind(this);
  }

  toggleMonthlyReport() {
    this.setState({ showMonthlyReport: !this.state.showMonthlyReport });
  }

  toggleFilters() {
    this.setState({ showFilters: !this.state.showFilters });
  }

  toggleExcludeVacway() {
    this.setState({ excludeVacway: !this.state.excludeVacway });
  }

  getDisplaySales() {
    const { sales } = this.props;
    if (!sales) return sales;
    if (!this.state.excludeVacway) return sales;
    return sales.filter((s) => {
      const id = s.Customer && s.Customer._id ? s.Customer._id.toString() : "";
      return id !== EXCLUDE_CUSTOMER_ID;
    });
  }

  componentDidMount() {
    const today = new Date().toISOString().substring(0, 10);

    // Start the timer when fetching sales data begins
    const startTime = performance.now();

    this.props
      .fetchSalesAnalysis("", "", today, today, "", "", "", "")
      .then((response) => {
        // Calculate the total time taken to fetch sales data
        const endTime = performance.now();
        const totalTimeInSeconds = (endTime - startTime) / 1000;
      })
      .catch((error) => {
        console.error("Error fetching sales data:", error);
      });

    this.props.fetchMachines();
  }

  calculateAverageTime() {
    const sales = this.getDisplaySales();

    if (!sales) {
      return;
    }

    let totalTime = 0;
    let indexTime = 0;

    sales.forEach((sale, index) => {
      if (sale.OperationTime > 0 && sale.OperationTime < 500) {
        totalTime += sale.OperationTime;

        if (sale.Amount > 0) {
          indexTime++;
        }
      }
    });

    totalTime = totalTime / indexTime;

    const minutes = Math.floor(totalTime / 60);
    const seconds = Math.floor(totalTime % 60)
      .toString()
      .padStart(2, "0");

    return (
      <div>
        {minutes}:{seconds}
      </div>
    );
  }

  calculatePercentageSales(type) {
    const sales = this.getDisplaySales();

    if (!sales) {
      return;
    }

    let totalSales = 0;
    let totalCash = 0;
    let percentageCash = 0;

    sales.forEach((sale, index) => {
      if (sale.Amount >= 0) {
        if (sale.PaymentMethod == type) {
          totalCash++;
        }

        totalSales++;
      } else if (sale.Amount < 0) {
        if (sale.PaymentMethod == type) {
          totalCash--;
        }
        totalSales--;
      }
    });

    percentageCash = ((totalCash / totalSales) * 100).toFixed(2);

    return percentageCash;
  }

  calculateBills5() {
    const sales = this.getDisplaySales();

    if (!sales) {
      return 0;
    }

    let bills5 = 0;

    sales.forEach((sale, index) => {
      if (sale.Amount > 0) {
        const detailsLines = sale.Details.split("\n");
        const bill5Pattern = "B: 5.00 €";

        detailsLines.forEach((line) => {
          if (line.includes(bill5Pattern)) {
            bills5++;
          }
        });
      }
    });

    return bills5;
  }

  calculateBills10() {
    const sales = this.getDisplaySales();

    if (!sales) {
      return 0;
    }

    let bills10 = 0;

    sales.forEach((sale, index) => {
      if (sale.Amount > 0) {
        const detailsLines = sale.Details.split("\n");
        const bill10Pattern = "B: 10.00 €";

        detailsLines.forEach((line) => {
          if (line.includes(bill10Pattern)) {
            bills10++;
          }
        });
      }
    });

    return bills10;
  }

  computeSalesTotals() {
    const sales = this.getDisplaySales();

    if (!sales) {
      return;
    }

    const itemIndices = new Map([
      ["LOCKERBNS", 0],
      ["LOCKERCNS", 1],
      ["LOCKERBWS", 2],
      ["LOCKERCWS", 3],
      ["LOCKERBNM", 4],
      ["LOCKERCNM", 5],
      ["LOCKERBWM", 6],
      ["LOCKERCWM", 7],
      ["LOCKERBNL", 8],
      ["LOCKERCNL", 9],
      ["LOCKERBWL", 10],
      ["LOCKERCWL", 11],
      ["LOCKERBNXL", 12],
      ["LOCKERCNXL", 13],
      ["LOCKERBWXL", 14],
      ["LOCKERCWXL", 15],
      ["LOCKERBN2XL", 16],
      ["LOCKERCN2XL", 17],
      ["LOCKERBW2XL", 18],
      ["LOCKERCW2XL", 19],
      ["LOCKERBN3XL", 20],
      ["LOCKERCN3XL", 21],
      ["LOCKERBW3XL", 22],
      ["LOCKERCW3XL", 23],
      // Voucher/Coupon Locker Types (XN and XW)
      ["LOCKERXNS", 24],
      ["LOCKERXWS", 25],
      ["LOCKERXNM", 26],
      ["LOCKERXWM", 27],
      ["LOCKERXNL", 28],
      ["LOCKERXWL", 29],
      ["LOCKERXNXL", 30],
      ["LOCKERXWXL", 31],
      ["LOCKERXN2XL", 32],
      ["LOCKERXW2XL", 33],
      ["LOCKERXN3XL", 34],
      ["LOCKERXW3XL", 35],
      ["TUMBONAS", 36],
      ["FLOTADORES", 37],
      ["FLOTADORESHALFDAY", 38],
      ["FASTPASS", 39],
    ]);

    let total = 0;
    let totalnotax = 0;

    // accumulate gross per machine+customer so we can apply per-machine rounding like the lambda
    const machineCustomerGross = new Map();
    const customerTax = new Map();

    let totalsPerMethod = new Map([
      [
        "CASH",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TPV",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "QR",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TOKEN",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "DEVOLUTION",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "PDA",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "FREE",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "CREDIT",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
    ]);

    let amount = 0;

    let amountsPerMethod = new Map([
      [
        "CASH",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TPV",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "QR",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TOKEN",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "DEVOLUTION",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "PDA",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "FREE",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "CREDIT",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
    ]);

    let qtyPerMethod = new Map([
      [
        "CASH",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TPV",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "QR",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "TOKEN",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "DEVOLUTION",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "PDA",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "FREE",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
      [
        "CREDIT",
        [
          0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
          0, 0, 0, 0, 0,
        ],
      ],
    ]);

    let totalsPerItem = new Map([
      ["LOCKERBNS", 0],
      ["LOCKERCNS", 0],
      ["LOCKERBWS", 0],
      ["LOCKERCWS", 0],
      ["LOCKERBNM", 0],
      ["LOCKERCNM", 0],
      ["LOCKERBWM", 0],
      ["LOCKERCWM", 0],
      ["LOCKERBNL", 0],
      ["LOCKERCNL", 0],
      ["LOCKERBWL", 0],
      ["LOCKERCWL", 0],
      ["LOCKERBNXL", 0],
      ["LOCKERCNXL", 0],
      ["LOCKERBWXL", 0],
      ["LOCKERCWXL", 0],
      ["LOCKERBN2XL", 0],
      ["LOCKERCN2XL", 0],
      ["LOCKERBW2XL", 0],
      ["LOCKERCW2XL", 0],
      ["LOCKERBN3XL", 0],
      ["LOCKERCN3XL", 0],
      ["LOCKERBW3XL", 0],
      ["LOCKERCW3XL", 0],
      ["TUMBONAS", 0],
      ["FLOTADORES", 0],
      ["FLOTADORESHALFDAY", 0],
      ["FASTPASS", 0],
    ]);

    for (let sale of sales) {
      let totalsPerSaleMethod = totalsPerMethod.get(sale.PaymentMethod);
      let amountsPerSaleMethod = amountsPerMethod.get(sale.PaymentMethod);
      let qtyPerSaleMethod = qtyPerMethod.get(sale.PaymentMethod);

      if (sale.Items) {
        for (let item of sale.Items) {
          let itemTotal = 0;
          let itemAmount = 0;

          itemTotal = item.price;
          itemAmount = item.price;

          if (sale.Amount != 0) {
            total += itemTotal;

            // do not accumulate per-item here; we'll accumulate per-sale below using sale.Amount
            // keep track of customer tax for later per-machine+customer net computation
            const custIdTmp =
              sale.Customer && sale.Customer._id
                ? sale.Customer._id.toString()
                : sale.Customer && sale.Customer.toString
                  ? sale.Customer.toString()
                  : "unknown";
            customerTax.set(
              custIdTmp,
              (sale.Customer && sale.Customer.Invoice_tax) || 0,
            );

            if (sale.Amount < 0) {
              amountsPerSaleMethod = amountsPerMethod.get("DEVOLUTION");
              totalsPerSaleMethod = totalsPerMethod.get("DEVOLUTION");
              qtyPerSaleMethod = qtyPerMethod.get("DEVOLUTION");
            }

            totalsPerSaleMethod[itemIndices.get(item.item)] += itemTotal;
            totalsPerItem.set(
              item.item,
              totalsPerItem.get(item.item) + itemTotal,
            );

            amount += itemAmount;
            amountsPerSaleMethod[itemIndices.get(item.item)] += itemAmount;
          }

          qtyPerSaleMethod[itemIndices.get(item.item)] += Math.abs(item.qty);
        }
      }

      // accumulate gross per machine+customer so we can apply per-machine rounding like the lambda
      if (sale.Amount != 0 && !["FREE", "TOKEN"].includes(sale.PaymentMethod)) {
        const custId =
          sale.Customer && sale.Customer._id
            ? sale.Customer._id.toString()
            : sale.Customer && sale.Customer.toString
              ? sale.Customer.toString()
              : "unknown";
        const machineId =
          sale.Machine && sale.Machine._id
            ? sale.Machine._id.toString()
            : sale.Machine
              ? sale.Machine.toString()
              : "noMachine";
        const key = `${machineId}:${custId}`;
        const prev = machineCustomerGross.get(key) || 0;
        machineCustomerGross.set(key, prev + sale.Amount);
        customerTax.set(
          custId,
          (sale.Customer && sale.Customer.Invoice_tax) || 0,
        );
      }

      if (sale.Amount < 0) {
        amountsPerMethod.set("DEVOLUTION", amountsPerSaleMethod);
        totalsPerMethod.set("DEVOLUTION", totalsPerSaleMethod);
        qtyPerMethod.set("DEVOLUTION", qtyPerSaleMethod);
      } else {
        amountsPerMethod.set(sale.PaymentMethod, amountsPerSaleMethod);
        totalsPerMethod.set(sale.PaymentMethod, totalsPerSaleMethod);
        qtyPerMethod.set(sale.PaymentMethod, qtyPerSaleMethod);
      }
    }

    // Round monetary values to cents for deterministic results
    const round2 = (v) => Math.round(v * 100) / 100;

    // compute totalnotax by applying per-machine rounding like generarArqueoVentas
    totalnotax = 0;
    for (let [key, gross] of machineCustomerGross) {
      const parts = key.split(":");
      const custId = parts.length > 1 ? parts[1] : parts[0];
      const tax = customerTax.get(custId) || 0;
      const net = tax ? Number((gross / (1 + tax / 100)).toFixed(2)) : gross;
      totalnotax += net;
    }

    total = round2(total);
    totalnotax = round2(totalnotax);
    amount = round2(amount);

    // debug: log QR diagnostics to help investigate missing QR in totalnotax
    try {
      const qrSales = sales.filter(
        (s) => (s.PaymentMethod || "").toString().toUpperCase() === "QR",
      );
      const qrCount = qrSales.length;
      const qrSumAll = round2(
        qrSales.reduce((s, r) => s + (Number(r.Amount || 0) || 0), 0),
      );
      const qrIncludedInGross = round2(
        Array.from(machineCustomerGross.entries()).reduce(
          (s, [k, v]) =>
            s +
            (v &&
            qrSales.some((rs) => {
              const custId =
                rs.Customer && rs.Customer._id
                  ? rs.Customer._id.toString()
                  : rs.Customer && rs.Customer.toString
                    ? rs.Customer.toString()
                    : "unknown";
              const key = custId;
              return key === k;
            })
              ? v
              : 0),
          0,
        ),
      );
      console.debug("SalesView: QR diagnostics", {
        qrCount,
        qrSumAll,
        qrIncludedInGross,
      });
    } catch (e) {
      console.debug("SalesView: QR diag error", e && e.message);
    }

    const roundArray = (arr) => arr.map((x) => round2(x));

    for (let [k, arr] of totalsPerMethod) {
      totalsPerMethod.set(k, roundArray(arr));
    }

    for (let [k, arr] of amountsPerMethod) {
      amountsPerMethod.set(k, roundArray(arr));
    }

    for (let [k, v] of totalsPerItem) {
      totalsPerItem.set(k, round2(v));
    }

    return {
      total: total,
      totalnotax: totalnotax,
      totalsPerMethod: totalsPerMethod,
      totalsPerItem: totalsPerItem,
      amount: amount,
      amountsPerMethod: amountsPerMethod,
      qtyPerMethod: qtyPerMethod,
    };
  }

  computeItemsTotals() {
    const sales = this.getDisplaySales();

    let totalQty = 0;

    let totalsPerItemQty = new Map([
      ["LOCKERBNS", 0],
      ["LOCKERCNS", 0],
      ["LOCKERBWS", 0],
      ["LOCKERCWS", 0],
      ["LOCKERBNM", 0],
      ["LOCKERCNM", 0],
      ["LOCKERBWM", 0],
      ["LOCKERCWM", 0],
      ["LOCKERBNL", 0],
      ["LOCKERCNL", 0],
      ["LOCKERBWL", 0],
      ["LOCKERCWL", 0],
      ["LOCKERBNXL", 0],
      ["LOCKERCNXL", 0],
      ["LOCKERBWXL", 0],
      ["LOCKERCWXL", 0],
      ["LOCKERBN2XL", 0],
      ["LOCKERCN2XL", 0],
      ["LOCKERBW2XL", 0],
      ["LOCKERCW2XL", 0],
      ["LOCKERBN3XL", 0],
      ["LOCKERCN3XL", 0],
      ["LOCKERBW3XL", 0],
      ["LOCKERCW3XL", 0],
      ["TUMBONAS", 0],
      ["FLOTADORES", 0],
      ["FLOTADORESHALFDAY", 0],
      ["FASTPASS", 0],
    ]);

    for (let sale of sales) {
      if (sale.Amount != 0) {
        for (let item of sale.Items) {
          let itemTotal = item.qty;

          totalQty += itemTotal;
          totalsPerItemQty.set(
            item.item,
            totalsPerItemQty.get(item.item) + itemTotal,
          );
        }
      }
    }

    return {
      totalQty: totalQty,
      totalsPerItemQty: totalsPerItemQty,
    };
  }

  handleSalesCSV() {
    const { fetchSalesCSV, form } = this.props;

    fetchSalesCSV(
      form.SalesFilterForm.values.Machine,
      form.SalesFilterForm.values.Customer,
      form.SalesFilterForm.values.StartDate,
      form.SalesFilterForm.values.EndDate,
      form.SalesFilterForm.values.Country,
      form.SalesFilterForm.values.Category,
      form.SalesFilterForm.values.PaymentMethod,
    );
  }

  handleSalesExcel() {
    const { fetchSalesExcel, form } = this.props;

    fetchSalesExcel(
      form.SalesFilterForm.values.Machine,
      form.SalesFilterForm.values.Customer,
      form.SalesFilterForm.values.StartDate,
      form.SalesFilterForm.values.EndDate,
      form.SalesFilterForm.values.Country,
      form.SalesFilterForm.values.Category,
      form.SalesFilterForm.values.PaymentMethod,
    );
  }

  salesTotalRow({ label, methods, totals, currency }) {
    return (
      <tr>
        <th scope="row">
          <h6 className="text-left text-vw-dark">{label}</h6>
        </th>
        {methods.map((method) => (
          <th scope="row" key={method}>
            {`${totals.amountsPerMethod.get(method).toLocaleString("es-ES", { style: "currency", currency })} / ${totals.qtyPerMethod.get(method)} u`}
          </th>
        ))}
      </tr>
    );
  }

  anyItemSale(totals, index) {
    if (
      totals.amountsPerMethod.get("CASH")[index] > 0 ||
      totals.amountsPerMethod.get("TPV")[index] > 0 ||
      totals.amountsPerMethod.get("TOKEN")[index] > 0 ||
      totals.amountsPerMethod.get("DEVOLUTION")[index] > 0 ||
      totals.amountsPerMethod.get("QR")[index] > 0 ||
      totals.amountsPerMethod.get("PDA")[index] > 0 ||
      totals.amountsPerMethod.get("FREE")[index] > 0 ||
      totals.amountsPerMethod.get("CREDIT")[index] > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  renderSalesTotals() {
    const { error, loading } = this.props;
    const sales = this.getDisplaySales();

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!sales || loading) {
      return <LoadingProgress />;
    }

    let totals = this.computeSalesTotals();
    let totalsQty = this.computeItemsTotals();

    const itemsArray = [
      "LOCKERBNS",
      "LOCKERCNS",
      "LOCKERBWS",
      "LOCKERCWS",
      "LOCKERBNM",
      "LOCKERCNM",
      "LOCKERBWM",
      "LOCKERCWM",
      "LOCKERBNL",
      "LOCKERCNL",
      "LOCKERBWL",
      "LOCKERCWL",
      "LOCKERBNXL",
      "LOCKERCNXL",
      "LOCKERBWXL",
      "LOCKERCWXL",
      "LOCKERBN2XL",
      "LOCKERCN2XL",
      "LOCKERBW2XL",
      "LOCKERCW2XL",
      "LOCKERBN3XL",
      "LOCKERCN3XL",
      "LOCKERBW3XL",
      "LOCKERCW3XL",
      "TUMBONAS",
      "FLOTADORES",
      "FLOTADORESHALFDAY",
      "FASTPASS",
    ];

    return (
      <>
        {/* KPI row at top of totals - local sales KPI styles (icon + title on top, value below) */}
        <div className="sales-kpi-row">
          <div className="sales-kpi-card income-day">
            <div className="kpi-icon">
              <i className="fas fa-euro-sign"></i>
            </div>
            <div className="kpi-content">
              <div className="kpi-label">Ventas con IVA</div>
              <div className="kpi-value">
                {totals.total.toLocaleString("es-ES", {
                  style: "currency",
                  currency: "EUR",
                })}
              </div>
            </div>
          </div>

          <div className="sales-kpi-card income-month">
            <div className="kpi-icon">
              <i className="fas fa-euro-sign"></i>
            </div>
            <div className="kpi-content">
              <div className="kpi-label">Ventas sin IVA</div>
              <div className="kpi-value">
                {totals.totalnotax.toLocaleString("es-ES", {
                  style: "currency",
                  currency: "EUR",
                })}
              </div>
            </div>
          </div>

          <div className="sales-kpi-card time">
            <div className="kpi-icon">
              <i className="fas fa-clock"></i>
            </div>
            <div className="kpi-content">
              <div className="kpi-label">Tiempo medio</div>
              <div className="kpi-value">{this.calculateAverageTime()}</div>
            </div>
          </div>
        </div>

        {/* original detailed table remains below */}
        <div className="sales-table-card">
          <div className="table-responsive">
            <table className="table table-sm table-stripped">
              <thead className="thead-dark">
                <tr>
                  <th scope="col"></th>
                  <th scope="col">
                    <h6 className="text-white">
                      CASH ({this.calculatePercentageSales("CASH")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      TPV ({this.calculatePercentageSales("TPV")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      QR ({this.calculatePercentageSales("QR")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      PDA ({this.calculatePercentageSales("PDA")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      GRATIS ({this.calculatePercentageSales("FREE")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      CREDITO ({this.calculatePercentageSales("CREDIT")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">
                      MANUAL ({this.calculatePercentageSales("TOKEN")}%)
                    </h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">DEVOLUCIONES</h6>
                  </th>
                  <th scope="col">
                    <h6 className="text-white">TOTAL</h6>
                  </th>
                </tr>
              </thead>
              <tbody>
                {itemsArray.map((item, index) => {
                  if (this.anyItemSale(totals, index)) {
                    return (
                      <tr key={item}>
                        <th scope="row">
                          <h6 className="text-left text-vw-dark">
                            {getLockersName(item)}
                          </h6>
                        </th>
                        <th scope="row">{`${totals.amountsPerMethod.get("CASH")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("CASH")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("TPV")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("TPV")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("QR")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("QR")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("PDA")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("PDA")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("FREE")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("FREE")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("CREDIT")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("CREDIT")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("TOKEN")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("TOKEN")[index]} u`}</th>
                        <th scope="row">{`${totals.amountsPerMethod.get("DEVOLUTION")[index].toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totals.qtyPerMethod.get("DEVOLUTION")[index]} u`}</th>
                        <th scope="row">{`${totals.totalsPerItem.get(item).toLocaleString("es-ES", { style: "currency", currency: "EUR" })} / ${totalsQty.totalsPerItemQty.get(item)} u`}</th>
                      </tr>
                    );
                  }
                  return null;
                })}
                {/* First row: Units */}
                <tr>
                  <th scope="row">
                    <h5 className="text-left text-vw-dark">TOTALES (u)</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("CASH").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("TPV").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("QR").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("PDA").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("FREE").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("CREDIT").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("TOKEN").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totals.qtyPerMethod.get("DEVOLUTION").reduce((a, b) => a + b, 0)} u`}</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">{`${totalsQty.totalQty} u`}</h5>
                  </th>
                </tr>
                {/* Second row: Amounts */}
                <tr>
                  <th scope="row">
                    <h5 className="text-left text-vw-dark">TOTALES (€)</h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("CASH")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("TPV")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("QR")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("PDA")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("FREE")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("CREDIT")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("TOKEN")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.totalsPerMethod
                        .get("DEVOLUTION")
                        .reduce((a, b) => a + b, 0)
                        .toLocaleString("es-ES", {
                          style: "currency",
                          currency: "EUR",
                        })}
                    </h5>
                  </th>
                  <th scope="row">
                    <h5 className="text-vw-light">
                      {totals.total.toLocaleString("es-ES", {
                        style: "currency",
                        currency: "EUR",
                      })}
                    </h5>
                  </th>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </>
    );
  }

  renderSalesStats() {
    const { machines, error, loading, auth } = this.props;
    const sales = this.getDisplaySales();

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!sales || loading || !machines) {
      return <LoadingProgress />;
    }

    return (
      <Box title="Estadísticas" icon="chart-bar">
        <SalesPlots sales={sales} machines={machines} />
      </Box>
    );
  }

  renderSales() {
    const { machines, error, loading, auth } = this.props;
    const sales = this.getDisplaySales();

    if (error) {
      return <ErrorMessage message={error.message} />;
    }

    if (!sales || loading || !machines) {
      return <LoadingProgress />;
    }

    return (
      <div>
        {this.renderSalesStats()}
        <Box title="Listado (100 ventas por página)">
          <SaleList auth={auth} />
        </Box>
      </div>
    );
  }

  render() {
    const { role, type } = this.props.auth;

    return (
      <div className="sales-admin-view">
        {/* header following Admin View guide */}
        <div className="sales-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-chart-line mr-3"></i> Ventas
              </h1>
            </div>
            <div className="header-actions">
              {role === "ADMIN" && (
                <>
                  <label
                    className="d-flex align-items-center mr-3"
                    title="Excluir VACWAY TECH"
                    style={{ gap: 8, cursor: "pointer", marginBottom: 0 }}
                  >
                    <span
                      style={{
                        fontSize: 12,
                        fontWeight: 600,
                        color: "#6b7280",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Excluir VACWAY
                    </span>
                    <div className="dashboard-switch">
                      <input
                        type="checkbox"
                        checked={this.state.excludeVacway}
                        onChange={this.toggleExcludeVacway}
                      />
                      <span className="slider round"></span>
                    </div>
                  </label>
                  <button
                    className="btn btn-outline-primary"
                    onClick={this.toggleMonthlyReport}
                  >
                    <i className="fas fa-calendar-alt mr-1"></i>Reporte Mensual
                  </button>
                </>
              )}
              <button
                className="btn btn-outline-primary ml-2"
                onClick={this.toggleFilters}
              >
                {this.state.showFilters ? (
                  <>
                    <i className="fas fa-chevron-up mr-1"></i>Ocultar filtros
                  </>
                ) : (
                  <>
                    <i className="fas fa-chevron-down mr-1"></i>Mostrar filtros
                  </>
                )}
              </button>
            </div>
          </div>
          {/* secondary action row: appears when toggled */}
          {this.state.showMonthlyReport && (
            <div className="header-row">
              <div className="month-picker-form">
                <MonthYearPickerForm />
              </div>
            </div>
          )}
        </div>

        {this.state.showFilters && (
          <div
            className="dashboard-header mb-3"
            style={{ padding: "12px 20px", justifyContent: "center" }}
          >
            <SalesFilterForm />
          </div>
        )}
        <div>{this.renderSalesTotals()}</div>
        {this.renderSales()}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  sales: state.sales.sales,
  error: state.sales.error,
  loading: state.sales.loading,
  auth: state.auth,
  form: state.form,
  machines: state.machines.machines,
  role: state.auth.role,
});

const mapDispatchToProps = (dispatch) => ({
  fetchSalesAnalysis: bindActionCreators(fetchSalesAnalysis, dispatch),
  fetchSalesCSV: bindActionCreators(fetchSalesCSV, dispatch),
  fetchSalesExcel: bindActionCreators(fetchSalesExcel, dispatch),
  fetchMachines: bindActionCreators(fetchMachines, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(SalesView);
